import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { CheckedCircleIcon, DangerIcon, LoadingIcon } from '../../Icons';

import './progressBar.css';

/*
#tailwind
progressBar progressBar--small progressBar--medium progressBar--large
progressBar__filledPortion progressBar__filledPortion--success progressBar__filledPortion--loading
progressBar__filledPortion--error  progressBar__icon progressBar__icon--success progressBar__icon--error progressBar__icon--loading
*/

const iconMap = {
  success: CheckedCircleIcon,
  error: DangerIcon,
  loading: LoadingIcon,
};
function ProgressBar({ progress, size, context, hasIcon, className, ...other }) {
  const Icon = useMemo(() => iconMap[context], [context]);

  return (
    <div className={bem`progressBar--${{ [size]: true }} ${className}`}>
      <div className="progressBar__unfilledPortion" {...other}>
        <div className={bem`progressBar__filledPortion--${{ [context]: true }}`} style={{ width: `${progress}%` }} />
      </div>
      {hasIcon && <Icon className={bem`progressBar__icon--${{ [context]: true }}`} />}
    </div>
  );
}

ProgressBar.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  progress: PropTypes.number,
  context: PropTypes.oneOf(['success', 'error', 'loading']),
  hasIcon: PropTypes.bool,
  className: PropTypes.string,
};

ProgressBar.defaultProps = {
  size: 'medium',
  progress: 0,
  context: 'success',
  hasIcon: false,
  className: undefined,
};

export default ProgressBar;
